<script>
  import projetoServico from '~modulos/projeto/servico';
  import estados from '~js/estados';
  import converterMoeda from '~js/converter-moeda';
  import Radio from '~componentes/Radio.vue';
  
  export default {
    components: { Radio },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false,
        default: false,
      },
      desabilitarBeneficiario: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        projetos: [],
        configuracao: this.$storage.configuracao(),
        estados: estados,
        desabilitarEndereco: false,
      }
    },
    methods: {
      permitirCriarSolicitacao(data) {
        return !(data && moment(data).add(1, "d").diff(moment()) < 0);
      },
      validar() {
        return this.$validator.validateAll();
      },
      listaDeProjetos() {
        return projetoServico
          .lista("SolContratacaoPessoal")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      setarProjeto(idProjeto) {
        this.projetos.map(projeto => {
          if (projeto.idProjeto == idProjeto) {
            this.$set(this.solicitacao, 'projeto', projeto);

            if (this.solicitacao.tipoSolicitacao == "1")
              this.$set(this.solicitacao, 'percentualEncargo', converterMoeda.paraReal(projeto.percentualEncargo));
            else
              this.$set(this.solicitacao, 'percentualEncargo', converterMoeda.paraReal(0));
          }
        });
      },
      iniciarSelect2Projeto() {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function(e) {
            _this.$set(_this.solicitacao, 'idProjeto', this.value);

            _this.setarProjeto(this.value);

            if (!this.value) return;
          });
      },
    },
    computed: {
      validarDataNascimento() {
        return this.configuracao.permitirCadPFSemDataNascimento ? 'date_format:DD/MM/YYYY' : 'required|date_format:DD/MM/YYYY'
      }
    },
    mounted() {
      this.listaDeProjetos();
      this.iniciarSelect2Projeto();
    },
    updated() {
      const _this = this;

      this.$watch('solicitacao.cep', function () {
        _this.getCEP();
      })
    },
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('projeto')}" v-if="!edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <select id="projeto"
                  class="form-control"
                  v-model="solicitacao.idProjeto"
                  data-vv-name="projeto"
                  v-validate="'required'">
            <option :value="projeto.idProjeto"
                    v-for="(projeto, index) in projetos"
                    :disabled="!permitirCriarSolicitacao(projeto.dataLimiteSolContratacaoPessoal) || projeto.acompanhamentoPendente || projeto.inativoDebito">
              {{ projeto.nomeProjeto }}

              <template v-if="!permitirCriarSolicitacao(projeto.dataLimiteSolContratacaoPessoal)">
                (Data limite até: {{ projeto.dataLimiteSolContratacaoPessoal | formatarData }})
              </template>

              <template v-if="projeto.acompanhamentoPendente && permitirCriarSolicitacao(projeto.dataLimiteSolContratacaoPessoal) && !projeto.inativoDebito">
                (Projeto bloqueado para solicitações, favor responder o acompanhamento deste projeto que está em atraso)
              </template>

              <template v-if="projeto.inativoDebito">
                (Projeto bloqueado para solicitações, pois o projeto está inativo para débito)
              </template>
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
        </div>

        <div class="form-group required" v-if="edicao">
          <label class="control-label" for="projeto">Projeto</label>

          <input type="text"
                 class="form-control"
                 v-model="solicitacao.projeto.nomeProjeto"
                 disabled>
        </div>
      </div>
    </div>

    <hr class="margin-top-10">

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group required" :class="{'has-error': errors.has('nomeRequerinte')}">
          <label class="control-label" for="nome-requerinte">Nome completo</label>

          <input type="text"
                 class="form-control"
                 id="nome-requerinte"
                 v-model="solicitacao.nomeRequerinte"
                 maxlength="100"
                 data-vv-name="nomeRequerinte"
                 data-vv-as="Nome do beneficiário"
                 v-validate="'required'"
                 :disabled="desabilitarBeneficiario">

          <p class="text-danger" v-show="errors.has('nomeRequerinte')">{{ errors.first('nomeRequerinte') }}</p>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group required">
          <label class="control-label" for="cpf">CPF</label>

          <input type="text"
                 class="form-control"
                 id="cpf"
                 v-model="solicitacao.cpf"
                 disabled>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataNascimento')}">
          <label class="control-label" for="nascimento">Data de nascimento</label>

          <input id="nascimento"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.dataNascimento"
                 v-mascara="'data'"
                 placeholder="    /    /"
                 data-vv-name="dataNascimento"
                 data-vv-as="data de nascimento"
                 v-validate="validarDataNascimento">

          <p class="text-danger" v-show="errors.has('dataNascimento')">{{ errors.first('dataNascimento') }}</p>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group required" :class="{'has-error': errors.has('tipo')}">
          <label class="control-label block">Tipo solicitação</label>

          <radio v-model="solicitacao.tipoSolicitacao"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 disabled
                 class="margin-right-10">
            Celetista
          </radio>
          <radio v-model="solicitacao.tipoSolicitacao"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 disabled
                 class="margin-right-10">
            Estagiário
          </radio>

          <p class="text-danger" v-show="errors.has('tipo')">{{ errors.first('tipo') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cep')}">
          <label class="control-label" for="cep">CEP</label>

          <input type="text"
                 class="form-control"
                 id="cep"
                 v-model="solicitacao.cep"
                 data-vv-as="cep"
                 data-vv-name="cep"
                 :disabled="desabilitarEndereco"
                 v-validate="'required'"
                 v-mascara="'cep'">

          <p class="text-danger" v-show="errors.has('cep')">{{ errors.first('cep') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group required" :class="{'has-error': errors.has('endereco')}">
          <label class="control-label" for="endereco">Endereço</label>

          <input id="endereco"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.endereco"
                 data-vv-name="endereco"
                 data-vv-as="endereço"
                 :disabled="desabilitarEndereco"
                 v-validate="'required'"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('endereco')">{{ errors.first('endereco') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('numero')}">
          <label class="control-label" for="numero">Número</label>

          <input id="numero"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.numero"
                 data-vv-name="numero"
                 data-vv-as="número"
                 v-validate="'required'"
                 maxlength="10">

          <p class="text-danger" v-show="errors.has('numero')">{{ errors.first('numero') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="complemento">Complemento</label>

          <input id="complemento"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.complemento"
                 maxlength="30">
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('bairro')}">
          <label class="control-label" for="bairro">Bairro</label>

          <input type="text"
                 class="form-control"
                 id="bairro"
                 v-model="solicitacao.bairro"
                 data-vv-as="bairro"
                 data-vv-name="bairro"
                 :disabled="desabilitarEndereco"
                 v-validate="'required'"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('bairro')">{{ errors.first('bairro') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cidade')}">
          <label class="control-label" for="cidade">Cidade</label>

          <input type="text"
                 class="form-control"
                 id="cidade"
                 v-model="solicitacao.cidade"
                 data-vv-as="cidade"
                 data-vv-name="cidade"
                 :disabled="desabilitarEndereco"
                 v-validate="'required'"
                 maxlength="60">

          <p class="text-danger" v-show="errors.has('cidade')">{{ errors.first('cidade') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('uf')}">
          <label class="control-label" for="uf">Estado</label>

          <select id="uf"
                  class="form-control"
                  v-model="solicitacao.uf"
                  data-vv-as="estado"
                  data-vv-name="uf"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="estado.sigla" v-for="estado in estados">{{ estado.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('uf')">{{ errors.first('uf') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <div class="form-group required" :class="{'has-error': errors.has('telefone')}">
          <label class="control-label" for="telefone">Telefone</label>

          <input type="text"
                 class="form-control"
                 id="telefone"
                 v-model="solicitacao.telefone"
                 data-vv-name="telefone"
                 data-vv-as="Telefone"
                 v-validate="'required'"
                 v-mascara="'telefone'">

          <p class="text-danger" v-show="errors.has('telefone')">{{ errors.first('telefone') }}</p>
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label" for="celular">Celular</label>

          <input type="text"
                 class="form-control"
                 id="celular"
                 v-model="solicitacao.celular"
                 v-mascara="'telefone'">
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group required" :class="{'has-error': errors.has('email')}">
          <label class="control-label" for="email">E-mail do beneficiário <small class="text-muted">(Para mais de um email separar utilizando ";")</small></label>

          <input type="text"
                 class="form-control"
                 id="email"
                 v-model="solicitacao.email"
                 maxlength="300"
                 data-vv-name="email"
                 data-vv-as="E-mail"
                 v-validate="`required|emailcomposto`"
                 v-caracteres-email>

          <p class="text-danger" v-show="errors.has('email')">{{ errors.first('email') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-contratacao-pessoal/componentes/compartilhado/FormDadosCadastrais.vue